import React from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";

import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import Box from "@mui/material/Box";
import {DefaultSettingsCreateFee} from "./DefaultSettingsCreateFee";
import {DefaultSettingFee} from "./DefaultSettingFee";
import {DefaultSettingsAcqFee} from "./DefaultSettingsAcqFee";
import {DefaultSettingsCreateRegFee} from "./DefaultSettingsCreateRegFee";
import {DefaultSettingsRegFee} from "./DefaultSettingsRegFee";


export const DefaultSettingsFees = ({fees, usState}) => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const isLoading = false

    const isAllStates = usState === 'ALL'

    const hasRegFee = fees.some(f => f.name === 'Registration Fee' && f.state === usState)

    return (
        <Box>
            <div className={'ds-section-title'}>
                Fees
            </div>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell
                            className={'header-cell'}
                            align="left"
                            width={isTabletOrMobile ? '60%' : '40%'}
                        >
                            Name
                        </TableCell>
                        {
                            !isTabletOrMobile &&
                            <React.Fragment>
                                <TableCell
                                    className={'header-cell'}
                                    align="center"
                                    width={'20%'}
                                >
                                    Taxable
                                </TableCell>
                                <TableCell
                                    className={'header-cell'}
                                    align="center"
                                    width={'20%'}
                                >
                                    Upfront/Capped
                                </TableCell>
                            </React.Fragment>
                        }
                        <TableCell
                            className={'header-cell'}
                            align="right"
                            width={isTabletOrMobile ? '40%' : '20%'}
                        >
                            Amount
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        isAllStates &&
                        <React.Fragment>
                            <DefaultSettingsAcqFee/>
                            <DefaultSettingsRegFee/>
                        </React.Fragment>
                    }
                    {
                        !isAllStates && !hasRegFee &&
                        <DefaultSettingsCreateRegFee usState={usState}/>
                    }
                    <DefaultSettingsCreateFee usState={usState}/>
                    {
                        fees.map((fee, idx) => {
                            return (
                                <DefaultSettingFee
                                    key={fee.id}
                                    fee={fee}
                                    isLoading={isLoading}
                                />
                            )
                        })
                    }
                </TableBody>
            </Table>
        </Box>
    )
}